import { stringify as qsify } from 'query-string';

import { WapiService } from 'wanderu-service-wapi';
import { memoize } from 'wanderu-utils';

async function _getCityByPlaceId(placeId) {
    const qs = {
        placeid: placeId,
    };

    const response = await WapiService.get(`cities.json?${qsify(qs)}`);
    // TODO: Format response plz
    return response?.result[0];
}

async function _getCityByWCityId(wCityId) {
    const qs = {
        fields: 'google',
        wcityid: wCityId,
    };

    return WapiService.get(`cities.json?${qsify(qs)}`);
}

async function getPopularRoutesByWCityId(wCityId) {
    const qs = {
        limit: 50,
        scope: 'departures',
        ids: wCityId,
        id_type: 'wcityid',
    };

    return await WapiService.get(`aggregate/popular.json?${qsify(qs)}`);
}

const getCityByPlaceId = memoize(_getCityByPlaceId);
const getCityByWCityId = memoize(_getCityByWCityId);

export {
    getCityByPlaceId,
    getCityByWCityId,
    getPopularRoutesByWCityId,
};

export default {
    getCityByPlaceId,
    getCityByWCityId,
    getPopularRoutesByWCityId,
};
